export default {
    name: 'LandingPagePuppyPackSection',
    components: {},
    directive: {},
    filters: {},
    mixins: [],
    props: {},
    data() {
        return {
			storeCredit: process.env.VUE_APP_STORE_CREDIT,
        }
    },
    computed: {},
    watch: {},
    created() {},
    methods: {},
    // third party libraries
}